<template>
  <div>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row class="mb-3">
          <b-col class="">
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Edit Order Info',
                true
              ) && order_master.tracking_obj
            " class="btn-action" size="sm" variant="info"
              :disabled="$store.state.user_obj.account_type == 'client_user'" :to="{
                name: 'order_master_edit',
                params: { id: order_master.id },
              }">Edit</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Edit Order Info - Customer',
                false
              ) && order_master.tracking_obj
            " class="btn-action" size="sm" variant="info" :disabled="order_master.stock_status == 'committed'" :to="{
              name: 'order_master_edit',
              params: { id: order_master.id },
            }">Edit</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Cancel Order',
                true
              )
            " class="btn-action" size="sm" variant="danger"
              :disabled="order_master.order_import_status == 'cancel' || $store.state.user_obj.account_type == 'client_user'"
              @click="doCancelOrder(order_master)">Cancel</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Rollback Order',
                true
              )
            " class="btn-action" size="sm" variant="danger"
              :disabled="$store.state.user_obj.account_type == 'client_user'"
              @click="doRollbackOrder(order_master)">Rollback</b-button>

            <b-button v-if="false &&
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Gen BO',
                true
              )
            " class="btn-action" size="sm" variant="danger" @click="doGenBO(order_master)">Generate BO</b-button>
          </b-col>
        </b-row>

        <h5>Order Info</h5>
        <b-row>
          <b-col class="col-2">
            <strong>Client Name</strong>
          </b-col>
          <b-col>{{ order_master.client_name }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Channel</strong>
          </b-col>
          <b-col>{{ order_master.channel }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Order #</strong>
          </b-col>
          <b-col>{{ order_master.order_number }}</b-col>
        </b-row>

        <!-- <b-row>
          <b-col class="col-2">
            <strong>Group ID</strong>
          </b-col>
          <b-col>{{ order_master.group_id }}</b-col>
        </b-row> -->

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col class="col-2">
            <strong>Priority</strong>
          </b-col>
          <b-col>{{ order_master.priority || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col class="col-2">
            <strong>Payment Status</strong>
          </b-col>
          <b-col>{{ order_master.payment_status || "-" }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col class="col-2">
            <strong>District</strong>
          </b-col>
          <b-col>{{ order_master.district || "-" }}</b-col>
        </b-row>

        <b-row v-if="
          order_master.related_orders &&
          order_master.related_orders.length > 0
        ">
          <b-col class="col-2">
            <strong>Related Orders</strong>
          </b-col>
          <b-col>
            <router-link target="_blank" :key="ri" v-for="(related_order, ri) in order_master.related_orders" :to="{
              name: 'order_master_detail',
              params: { order_master_id: related_order.id },
            }">
              {{ related_order.order_number }}
            </router-link>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Upload Date</strong>
          </b-col>
          <b-col>
            {{ displayDate(order_master.created_at) }}
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Order Date</strong>
          </b-col>
          <b-col>
            {{ displayDate(order_master.order_date) }}
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Scheduled Delivery</strong>
          </b-col>
          <b-col>
            {{ displayDate(order_master.scheduled_delivery_date) }}
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Customer Name</strong>
          </b-col>
          <b-col>{{ order_master.customer_name }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Customer Phone</strong>
          </b-col>
          <b-col>{{ order_master.customer_phone || "-" }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Customer Address</strong>
          </b-col>
          <b-col>{{ order_master.customer_address }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Customer Email</strong>
          </b-col>
          <b-col>{{ order_master.customer_email || "-" }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong># of ctns</strong>
          </b-col>
          <b-col>{{ order_master.no_of_ctns || "-" }}</b-col>
        </b-row>

        <b-row v-if="order_master.order_type == 'Collect & Delivery'">
          <b-col class="col-2">
            <strong>Collection Store</strong>
          </b-col>
          <b-col>{{ order_master.collection_store || "-" }}</b-col>
        </b-row>

        <b-row v-if="order_master.order_type == 'Collect & Delivery'">
          <b-col class="col-2">
            <strong>Collection Date</strong>
          </b-col>
          <b-col>{{ order_master.collection_date || "-" }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Last Updated</strong>
          </b-col>
          <b-col>{{ order_master.updated_at }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Order Status</strong>
          </b-col>
          <b-col>
            <div>
              <span class="txt_camelcase">{{
                order_master.order_import_status
              }}</span>

              <span v-if="order_master.order_import_status == 'cancel'" class="dot_red"></span>
              <span v-if="order_master.order_import_status == 'hold'" class="dot_red"></span>
              <span v-if="order_master.order_import_status == 'pending'" class="dot_yellow"></span>
              <span v-if="order_master.order_import_status == 'received'" class="dot_green"></span>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Stock Status</strong>
          </b-col>
          <b-col>
            <div>
              <span class="txt_camelcase">{{ order_master.stock_status }}</span>

              <span v-if="order_master.stock_status == '-'" class="dot_white"></span>
              <span v-if="order_master.stock_status == 'pending'" class="dot_red"></span>
              <span v-if="order_master.stock_status == 'available'" class="dot_yellow"></span>
              <span v-if="order_master.stock_status == 'committed'" class="dot_green"></span>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Fulfilment Status</strong>
          </b-col>
          <b-col>
            <div>
              <span class="txt_camelcase">{{
                order_master.fulfilment_status
              }}</span>

              <span v-if="order_master.fulfilment_status == '-'" class="dot_white"></span>
              <span v-if="order_master.fulfilment_status == 'pending'" class="dot_yellow"></span>
              <span v-if="order_master.fulfilment_status == 'completed'" class="dot_green"></span>
              <span v-if="order_master.fulfilment_status == 'fulfiled'" class="dot_green"></span>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Remarks</strong>
          </b-col>
          <b-col>{{ order_master.remarks || "-" }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Delivery Remarks</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">{{
            order_master.tracking_obj.remark || "-"
          }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Pack by GOLS</strong>
          </b-col>
          <b-col>{{
            order_master.pack_by_gols == 1 ? "Yes" : "No"
          }}</b-col>
        </b-row>
      </b-card>

      <b-card class="mb-1">
        <b-button v-if="
          checkPermission(
            $store.state.user_obj,
            'Order Management',
            'Order Master/Detail/',
            'Edit Tracking Info',
            true
          ) && order_master.tracking_obj
        " class="btn-action mb-3" size="sm" variant="info" :to="{
          name: 'tracking_edit',
          params: { id: order_master.tracking_obj.id },
        }">Edit</b-button>
        <h5>Tracking Info</h5>
        <b-row>
          <b-col class="col-2">
            <strong>Courier Name</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">{{
            order_master.tracking_obj.courier_short_name
          }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Tracking #</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">
            <router-link :to="{
              name: 'tracking_detail',
              params: { id: order_master.tracking_obj.id },
            }">
              {{ order_master.tracking_obj.tracking_number }}
            </router-link>
          </b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col class="col-2">
            <strong>Route</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">{{
            order_master.tracking_obj.route || "-"
          }}</b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col class="col-2">
            <strong>Packing Sector</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">{{
            order_master.tracking_obj.packing_sector || "-"
          }}</b-col>
        </b-row>

        <b-row v-if="!(($store.state.user_obj.account_type == 'client_user')
          && order_master.tracking_obj.pod_type == 'photo'
        ) && $store.state.user_obj.account_type != 'client_user_masked'">
          <b-col class="col-2">
            <strong>POD</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">
            <b-button class="btn-action txt_camelcase" size="sm" variant="info"
              v-if="order_master.tracking_obj.pod_image" @click="showPod(order_master.tracking_obj)">{{
                order_master.tracking_obj.pod_type }}</b-button>

            <b-button class="btn-action" size="sm" variant="danger" v-if="order_master.tracking_obj.pod_image"
              @click="showModal_removePod(order_master.tracking_obj)">Remove POD</b-button>
            <span v-if="!order_master.tracking_obj.pod_image">-</span>
          </b-col>
        </b-row>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col class="col-2">
            <strong>Carried by</strong>
          </b-col>
          <b-col v-if="order_master.tracking_obj">{{
            order_master.tracking_obj.carried_by_name || "-"
          }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Packing Printed</strong>
          </b-col>
          <b-col>{{ order_master.packing_print_at || "-" }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Waybill Printed</strong>
          </b-col>
          <b-col>{{ order_master.waybill_print_at || "-" }}</b-col>
        </b-row>
      </b-card>

      <b-card class="mb-1" v-if="order_master.tracking_obj">
        <h5>Tracking Status</h5>

        <b-table responsive small outlined striped hover :items="history_items" :fields="history_fields">
          <template v-slot:cell(status)="data">
            {{ data.item.status }}
            <!-- <span v-if="data.item.status_reason"
              >- {{ data.item.status_reason }}</span
            > -->
            <span v-if="data.item.other_reason">
              <br />
              [{{ data.item.other_reason }}]
            </span>

            <span v-if="data.item.reschedule_delivery_date">
              <br />
              [{{ data.item.reschedule_delivery_date }}]
            </span>
          </template>

          <template v-slot:cell(updated_by)="data">
            <span v-if="$store.state.user_obj.account_type != 'young_living'">
              {{ data.item.updated_by_name }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'young_living'">
              <span v-if="data.item.updated_by_type == 'driver'"> Driver </span>
              <span v-if="data.item.updated_by_type != 'driver'">
                {{ data.item.updated_by_name }}
              </span>
            </span>
          </template>

          <template v-slot:cell(pod_image)="data">
            <a v-if="(!(($store.state.user_obj.account_type == 'client_user')
              && order_master.tracking_obj.pod_type == 'photo'
            ) && $store.state.user_obj.account_type != 'client_user_masked') && data.item.pod_image"
              :href="data.item.pod_image" target="_blank">{{ data.item.pod_type }}</a>
            <span v-if="((($store.state.user_obj.account_type == 'client_user')
              && order_master.tracking_obj.pod_type == 'photo'
            ) && $store.state.user_obj.account_type != 'client_user_masked') || !data.item.pod_image">-</span>
          </template>

          <template v-slot:cell(action)="data">
            <b-button class="btn-action" size="sm" variant="danger"
              v-if="$store.state.user_obj.account_type != 'young_living'"
              @click.stop="showModal_cancelTracking(data.item)">Delete</b-button>
          </template>
        </b-table>
      </b-card>

      <b-card class="mb-1">
        <h5>Delivery Case</h5>
        <p v-if="cr_items.length == 0">No results</p>
        <b-table v-if="cr_items.length > 0" responsive small outlined striped hover :items="cr_items"
          :fields="cr_fields">
          <template v-slot:cell(status)="data">{{ data.item.status }}</template>

          <template v-slot:cell(field_name)="data">
            <span v-if="data.item.field_name != 'courier_short_name'">{{
              data.item.field_name
            }}</span>

            <span v-if="data.item.field_name == 'courier_short_name'">
              courier
            </span>
          </template>

          <template v-slot:cell(changes)="data">
            <div style="
                max-width: 250px;
                white-space: pre-line;
                word-break: break-word;
              ">
              {{ data.item.to_val }}
              <div v-if="data.item.other_reason"></div>
            </div>
          </template>

          <template v-slot:cell(remark)="data"> </template>

          <template v-slot:cell(updated_at)="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.updated_at }}
            </div>
          </template>

          <template v-slot:cell(action)="data">
            <b-button class="btn-action" size="sm" variant="info" :to="{
              name: 'tracking_detail',
              params: { id: data.item.tracking_id },
            }" :disabled="!data.item.tracking_id">Detail</b-button>

            <b-button v-if="
              ($store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs' ||
                $store.state.user_obj.account_type == 'client_admin') &&
              data.item.status == 'pending'
            " class="btn-action" size="sm" variant="success" @click.stop="executeCR(data.item)">Execute</b-button>

            <b-button v-if="data.item.status == 'pending'" class="btn-action" size="sm" variant="danger"
              @click.stop="cancelCR(data.item)">Cancel</b-button>
          </template>
        </b-table>
      </b-card>

      <!-- <b-card class="mb-1">
        <h5>CS Case</h5>

        <cs-issue-card
          :key="item_index"
          v-for="(item, item_index) inrcs_items"
          :item="item"
          :mode="
            $store.state.user_obj.account_type == 'admin' ||
            $store.state.user_obj.account_type == 'cs'
              ? 'edit'
              : 'view'
          "
        ></cs-issue-card>
      </b-card> -->

      <!-- <b-card class="mb-1">
        <h5>Delivery Note</h5>
        <b-row>
          <b-col class="col-2">
            <strong>...</strong>
          </b-col>
          <b-col>...</b-col>
        </b-row>
      </b-card> -->

      <b-card class="mt-1">
        <h5>Products</h5>

        <b-row v-if="$store.state.user_obj.account_type != 'client_user'">
          <b-col cols="3" class="pr-1">
            <b-form-input size="sm" type="text" placeholder="Channel SKU"
              v-model="addsku_obj.channel_sku"></b-form-input>
          </b-col>

          <b-col cols="1" class="pl-0 pr-1">
            <b-form-input size="sm" type="text" v-model="addsku_obj.quantity" placeholder="Quantity"></b-form-input>
          </b-col>

          <b-col class="pl-0">
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Add SKU',
                true
              )
            " class="btn-action mb-3" size="sm" variant="info" @click="addSKU()">Add SKU</b-button>
          </b-col>
        </b-row>

        <b-table responsive small outlined striped hover :items="order_master_products" :fields="product_fields">
          <template v-slot:cell(cover_image)="data">
            <img :src="data.item.cover_image" width="50" />
          </template>

          <template v-slot:cell(product_channel_sku)="data">
            <span>{{ data.item.product_channel_sku }}</span>
            <b-badge v-if="data.item.invalid_sku == '1'" variant="danger" class="ml-1">
              Invalid SKU
            </b-badge>
          </template>

          <template v-slot:cell(brand)="data">
            {{ data.item.brand || "-" }}
          </template>

          <template v-slot:cell(stock_status)="data">
            <span v-if="data.item.stock_status != 'back_order'">{{
              data.item.stock_status
            }}</span>

            <router-link target="_blank" v-if="data.item.stock_status == 'back_order'" :to="{
              name: 'order_master_detail',
              params: { order_master_id: data.item.bo_id },
            }">
              {{ data.item.stock_status }} ({{ data.item.bo_number }})
            </router-link>
          </template>
          <template v-slot:cell(action)="data">
            <b-button v-if="
              data.item.invalid_sku == '1' &&
              order_master.stock_status != 'committed' &&
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Edit Product',
                true
              )
            " class="btn-action" size="sm" variant="danger" @click.stop="deleteInvalidProduct(data.item)">Delete</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Edit Order Info - Customer',
                false
              ) &&
              order_master.pack_by_gols == 1
            " class="btn-action" size="sm" variant="info" @click.stop="openProductModal(data.item)"
              :disabled="data.item.committed_qty > 0">Edit</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Edit Order Info - Customer',
                false
              ) &&
              data.item.stock_status != 'cancel' &&
              data.item.stock_status != 'committed' &&
              order_master.pack_by_gols == 1
            " class="btn-action" size="sm" variant="danger" @click.stop="cancelProduct(data.item)">Cancel</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Edit Product',
                true
              ) &&
              $store.state.user_obj.account_type != 'client_user' &&
              order_master.pack_by_gols == 1
            " class="btn-action" size="sm" variant="info" @click.stop="openProductModal(data.item)"
              :disabled="data.item.committed_qty > 0">Edit</b-button>
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Cancel Product',
                true
              ) &&
              $store.state.user_obj.account_type != 'client_user' &&
              data.item.stock_status != 'cancel' &&
              data.item.stock_status != 'committed' &&
              order_master.pack_by_gols == 1
            " class="btn-action" size="sm" variant="danger" @click.stop="cancelProduct(data.item)">Cancel</b-button>
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master/Detail/',
                'Rollback Product',
                true
              ) &&
              $store.state.user_obj.account_type != 'client_user' &&
              order_master.pack_by_gols == 1
              && order_master.fulfilment_status != 'fulfiled'
              && order_master.stock_status != 'committed'
            " class="btn-action" size="sm" variant="danger"
              @click.stop="rollbackProduct(data.item)">Rollback</b-button>
            <!-- <b-button
              class="btn-action"
              size="sm"
              variant="danger"
              v-if="$store.state.user_obj.account_type != 'young_living'"
              @click.stop="showModal_cancelTracking(data.item)"
              >Delete</b-button
            > -->
          </template>
        </b-table>
      </b-card>

      <b-card class="mt-1" v-if="$store.state.user_obj.account_type != 'client_user'">
        <h5>Transactions</h5>
        <p v-if="transaction_items.length == 0">No results</p>
        <b-table v-if="transaction_items.length > 0" responsive small outlined striped hover sticky-header="500px"
          :items="transaction_items" :fields="transaction_fields">
          <template v-slot:cell(action_at)="data">
            <div>
              {{ displayDate(data.item.action_at) }}
            </div>
          </template>

          <template v-slot:cell(stock_in_date)="data">
            <div>
              {{ displayDate(data.item.stock_in_date) }}
            </div>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button v-if="
              $store.state.user_obj.account_type == 'client_admin' ||
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inventory - Transactions',
                'Edit',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="openEditRemarkModal(data.item)">Edit</b-button>
          </template>
        </b-table>
      </b-card>

      <b-card class="mt-1">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mt-3 mb-0">Documents</h5>

          <b-button class="btn-action" size="sm" variant="success"
            :disabled="!document_items || document_items.length === 0" @click="downloadAllDocs">
            Download All
          </b-button>
        </div>

        <div class="search_bar mb-3 mt-3">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-input id="input-small" type="text" placeholder="Document Name"
                v-model="new_doc_record.name"></b-form-input>
            </b-col>
            <b-col cols="3" class="pl-0 pr-1">
              <b-form-file v-model="new_doc_record.upload_file" placeholder="Choose a file..."></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" variant="info" @click="onUploadFile">Add</b-button>
            </b-col>
          </b-row>
        </div>

        <b-table responsive small outlined striped hover :items="document_items" :fields="document_fields">
          <template v-slot:cell(document_name)="data">
            <a :href="data.item.url" target="_blank">
              {{ data.item.document_name }}
            </a>
          </template>

          <template v-slot:cell(created_at)="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.created_at }}
            </div>
          </template>

          <template v-slot:cell(action)="data">
            <div>
              <b-button class="btn-action" size="sm" variant="danger" @click.stop="removeDoc(data.item)">
                Remove
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card>

      <b-modal id="modal-prevent-closing" ref="modal" title="Edit Product" @show="resetProductModal"
        @hidden="resetProductModal" @ok="handleProductOk">
        <form ref="form" @submit.stop.prevent="handleProductSubmit">
          <b-form-group label="Quantity" label-for="quantity-input" :invalid-feedback="'Quantity is required'"
            :state="productState.quantityState">
            <b-form-input id="quantity-input" v-model="product_obj.quantity" :state="productState.quantityState"
              type="number" min="1"></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const product_fields = [
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "product_channel_sku",
    label: "Other SKU",
  },
  {
    key: "brand",
    label: "Brand",
  },
  {
    key: "product_description",
    label: "Product Description",
  },
  {
    key: "product_qty",
    label: "Quantity",
  },
  {
    key: "committed_qty",
    label: "Committed",
  },
  {
    key: "stock_status",
    label: "Stock Status",
  },
  {
    key: "action",
    label: "Action",
  },
];

import global_function from "../mixins/global_function";

export default {
  name: "OrderMasterDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
  },
  mixins: [global_function],
  data() {
    return {
      addsku_obj: {
        product_sku: null,
        quantity: null,
      },
      order_master: false,
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Order Master",
          to: { name: "order_master" },
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      loader: false,
      order_master_products: [],
      cr_items: [],
      cr_fields: [
        {
          key: "field_name",
          label: "Field Name",
        },
        {
          key: "changes",
          label: "Changes",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "created_by",
          label: "Requested By",
        },
        {
          key: "updated_by",
          label: "Executed By",
        },
      ],
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "pod_image",
          label: "POD",
        },
        {
          key: "updated_by",
          label: "Updated by",
        },
        // {
        //   key: "action",
        //   label: "Action"
        // }
      ],
      product_fields: product_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      selectedOrderItem: null,
      product_obj: {
        quantity: null,
      },
      productState: {
        quantityState: null,
      },
      transaction_items: [],
      transaction_fields: [
        {
          key: "channel",
          label: "Channel",
        },
        {
          key: "product_sku",
          label: "Product SKU",
        },
        {
          key: "channel_sku",
          label: "Channel SKU",
        },
        {
          key: "vendor_lot_number",
          label: "Lot #",
        },
        {
          key: "product_description",
          label: "Item Description",
        },
        {
          key: "quantity",
          label: "Qty",
          class: "center_align",
        },
        {
          key: "action",
          label: "Action",
          class: "center_align txt_camelcase",
        },

        {
          key: "stock_in_date",
          label: "SID",
          class: "center_align",
        },
        {
          key: "from_location",
          label: "From Location",
          class: "center_align",
        },
        {
          key: "from_inventory_type",
          label: "From Inventory Type",
          class: "center_align txt_camelcase",
        },
        {
          key: "to_location",
          label: "To Location",
          class: "center_align",
        },
        {
          key: "to_inventory_type",
          label: "To Inventory Type",
          class: "center_align txt_camelcase",
        },
        {
          key: "remark",
          label: "Remark",
        },
        {
          key: "action_by_name",
          label: "Action by",
        },
        {
          key: "action_at",
          label: "Action at",
        },
        {
          key: "remark",
          label: "Remark",
        },
      ],
      new_doc_record: {},
      document_items: [],
      document_fields: [
        {
          key: "document_name",
          label: "Document Name"
        },
        {
          key: "created_by",
          label: "Created By"
        },
        {
          key: "created_at",
          label: "Created at"
        },
        {
          key: "action",
          label: "Action"
        }
      ],
    };
  },
  async created() {
    await this.getOrderMasterDetail();
    await this.getOrderMasterProduct();
    await this.getOrderMasterTransactions();
    await this.getChangeRequests();
    await this.getOrderMaster_Docs();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getOrderMasterDetail() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      if (response.data.orders && response.data.orders.length > 0) {
        this.order_master = response.data.orders[0];
      }

      this.history_items = response.data.tracking_status_historys;

      this.loader.hide();
    },

    async getOrderMasterProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_get.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      this.order_master_products = response.data.products;

      this.loader.hide();
    },

    async getOrderMasterTransactions() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_transaction_get.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.transaction_items = response.data.transactions;

      this.loader.hide();
    },

    async saveRemark() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_remark_save.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          remark: this.order_master.remark,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      this.getOrderMasterDetail();
    },

    async getChangeRequests() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_get.php",
        data: {
          search_criteria: {
            order_number: this.order_master.order_number,
          },
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      this.cr_items = response.data.change_requests;
      this.loader.hide();
    },

    async executeCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_execute.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      if (response.data.status == "success") {
        this.getTracking();
        this.getChangeRequests();
      } else {
        alert(response.data.error_msg);
      }
    },

    async cancelCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_cancel.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.getChangeRequests();
    },

    async cancelProduct(product_item) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to cancel product.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_cancel.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          order_product_id: product_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        // this.$eventHub.$emit("show_alert_message", {
        //     alert_message: "Cancel Product Success",
        //     variant: "success"
        // });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Cancel Product Failed",
          variant: "danger"
        });
      }

      this.loader.hide();
      this.getOrderMasterProduct();
    },

    async deleteInvalidProduct(product_item) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to permanently delete this invalid SKU from the order. This cannot be undone.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_delete_invalid.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          order_product_id: product_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Invalid SKU Deleted",
          variant: "success",
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Delete Failed",
          variant: "danger",
        });
      }

      this.loader.hide();
      this.getOrderMasterProduct();
    },

    async showPod(item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_pod_get.php",
        data: {
          tracking_id: item.id,
          tracking_number: item.tracking_number,
        },
      });

      item.order_ids = response.data.order_ids;
      item.pod_at = response.data.pod_at;

      this.$eventHub.$emit("show_image_view", {
        image_url: item.pod_image,
        order_ids: item.order_ids,
        pod_at: item.pod_at,
      });
    },

    async getCsIssues() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: {
            tracking_id: this.tracking.id,
          },
        },
      });
      this.items = response.data.cs_issues;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    async addSKU() {
      if (this.addsku_obj.channel_sku == "" || this.addsku_obj.quantity == "") {
        return;
      }

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_add_sku.php",
        data: {
          channel_sku: this.addsku_obj.channel_sku,
          quantity: this.addsku_obj.quantity,
          order_master_id: this.$route.params.order_master_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      console.log(response);

      if (response.data.status != "success" && response.data.message) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message,
        });
      }

      this.getOrderMasterProduct();

      this.loader.hide();
    },

    async doCancelOrder(row_data) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to cancel order.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_cancel.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Cancel Order Success",
          variant: "success"
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Cancel Order Failed",
          variant: "danger"
        });
      }


      this.loader.hide();
      this.getOrderMasterDetail();
      this.getOrderMasterProduct();
    },

    async doRollbackOrder(row_data) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to rollback order.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      // return;
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_rollback.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Rollback Order Success",
          variant: "success"
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Rollback Order Failed",
          variant: "danger"
        });
      }

      this.loader.hide();
      this.getOrderMasterDetail();
      this.getOrderMasterProduct();
    },

    async doGenBO(row_data) {
      // return;
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_gen_bo.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Generate Back Order Success",
        variant: "success",
      });

      this.loader.hide();
      this.getOrderMasterDetail();
      this.getOrderMasterProduct();
    },

    checkProductFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.productState.quantityState = this.$refs.form
        .querySelector("#quantity-input")
        .checkValidity();
      return valid;
    },

    openProductModal(item) {
      this.$bvModal.show("modal-prevent-closing");
      this.selectedOrderItem = item;
      this.product_obj.quantity = item.product_qty;
    },

    resetProductModal() {
      this.product_obj = {
        quantity: null,
      };

      this.productState = {
        quantityState: null,
      };
    },

    async handleProductOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.handleProductSubmit();
    },

    async handleProductSubmit() {
      if (!this.checkProductFormValidity()) {
        return;
      }

      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to update quantity to ${this.product_obj.quantity}.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_edit.php",
        data: {
          product_obj: this.product_obj,
          order_product_obj: this.selectedOrderItem,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.loader.hide();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });

      if (response.data.status == "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Order is updated Successfully",
          variant: "success",
        });
      } else {
        alert(response.data.message);
      }

      this.getOrderMasterProduct();
    },

    async rollbackProduct(product_item) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to rollback.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_rollback.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          order_product_id: product_item.id,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status == "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Rollback Success",
          variant: "success",
        });
      } else if (response.data.message) {
        alert(response.data.message);
      }

      this.getOrderMasterProduct();
    },

    async removeDoc(doc_item) {
      let confirmed = await this.$bvModal.msgBoxConfirm(
        `Please confirm that you want to remove document.`,
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) return;

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_doc_remove.php",
        data: {
          doc_id: doc_item.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        // this.$eventHub.$emit("show_alert_message", {
        //     alert_message: "Cancel Product Success",
        //     variant: "success"
        // });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Remove Failed",
          variant: "danger"
        });
      }

      this.loader.hide();
      this.getOrderMaster_Docs();
    },

    async onAddFile() {
      if (this.new_doc_record.upload_file == null) {
        return;
      }

      if (this.new_doc_record.name == '') {
        return;
      }
      let doc_record = {
        document_name: this.new_doc_record.name,
        upload_file: this.new_doc_record.upload_file,
        created_by: '-',
        created_at: '-',
      };

      this.document_items.push(doc_record);

      this.new_doc_record = {};

    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("doc_file", this.new_doc_record.upload_file);
      formData.append("document_name", this.new_doc_record.name);
      formData.append("order_master_id", this.$route.params.order_master_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_upload_document.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
      this.new_doc_record = {};
      this.getOrderMaster_Docs();
    },

    async getOrderMaster_Docs() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_doc_get.php",
        data: {
          order_master_id: this.$route.params.order_master_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.document_items = response.data.order_master_docs;

      this.loader.hide();
    },

    async downloadAllDocs() {
      if (!this.document_items || this.document_items.length === 0) {
        return;
      }

      const url =
        `${this.API_HOST}/order_master_doc_download_all.php` +
        `?order_master_id=${encodeURIComponent(this.$route.params.order_master_id)}` +
        `&client_id=${encodeURIComponent(this.$store.state.user_obj.client_id)}` +
        `&user_id=${encodeURIComponent(this.$store.state.user_obj.user_id)}`;

      window.open(url, "_blank");
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderMasterDetail.vue